var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1111 11.1111H13.3333C12.106 11.1111 11.1111 12.106 11.1111 13.3333V28.8889C11.1111 30.1162 12.106 31.1111 13.3333 31.1111H20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1111 11.1111H13.3333C12.106 11.1111 11.1111 12.106 11.1111 13.3333V28.8889C11.1111 30.1162 12.106 31.1111 13.3333 31.1111H20",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8888 11.1111H26.6666C27.8939 11.1111 28.8888 12.106 28.8888 13.3333V23.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8888 11.1111H26.6666C27.8939 11.1111 28.8888 12.106 28.8888 13.3333V23.3333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5555 13.7778V11.6667C15.5555 11.3598 15.8043 11.1111 16.1111 11.1111C16.4179 11.1111 16.6713 10.8623 16.7239 10.56C16.8885 9.61301 17.5266 7.77778 20 7.77778C22.4733 7.77778 23.1114 9.61301 23.2761 10.56C23.3287 10.8623 23.5821 11.1111 23.8889 11.1111C24.1957 11.1111 24.4444 11.3598 24.4444 11.6667V13.7778C24.4444 14.146 24.146 14.4444 23.7778 14.4444H16.2222C15.854 14.4444 15.5555 14.146 15.5555 13.7778Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5555 13.7778V11.6667C15.5555 11.3598 15.8043 11.1111 16.1111 11.1111C16.4179 11.1111 16.6713 10.8623 16.7239 10.56C16.8885 9.61301 17.5266 7.77778 20 7.77778C22.4733 7.77778 23.1114 9.61301 23.2761 10.56C23.3287 10.8623 23.5821 11.1111 23.8889 11.1111C24.1957 11.1111 24.4444 11.3598 24.4444 11.6667V13.7778C24.4444 14.146 24.146 14.4444 23.7778 14.4444H16.2222C15.854 14.4444 15.5555 14.146 15.5555 13.7778Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8888 29.4444L26.111 31.6667L31.6666 26.1111",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8888 29.4444L26.111 31.6667L31.6666 26.1111",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/orders-icon.20d10d9c0b6b2a6429075901b6f9d264.svg";
export { ForwardRef as ReactComponent };